module.exports = __webpack_public_path__ + "img/de.e88d8860.svg";